/** @format */
import React, { FunctionComponent, ReactElement, useState } from 'react';
import { Checkbox, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import adescomStyle from '../../../../../assets/jss/adescom/adescomStyle';
import { SimCardServiceItem } from '../../../../../interfaces/collections/SimCardServiceInterface';
import I18n from '../../../../../components/Translate/I18n';
import GridItem from '../../../../../components/Grid/GridItem';
import GridContainer from '../../../../../components/Grid/GridContainer';
import { OplBmeUsage } from './OplBmeUsage';
import { DateHelperTs } from '../../../../../helpers/DateHelperTs';
import i18next from 'i18next';
import AlertInfo from '../../../../../components/Info/AlertInfo';
import { ItemLoaders } from '../../../../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../../../../helpers/FormGeneral';
import { ComponentParam } from '../../ComponentByGroup';

const useStyle = makeStyles(adescomStyle);

type BmeParamsType = {
    simCardService: SimCardServiceItem;
};

interface ServiceComponentParam {
    name: string;
    value: string | number | null;
}

export const BmeParams: FunctionComponent<BmeParamsType> = ({ simCardService }): ReactElement | null => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const [disableRenew, setDisableRenew] = useState(false);
    const [alert, setAlert] = useState<any>(null);

    const tableCellRoot = { root: classes.tableCellRoot };

    let isComponentParams = false;
    let jsonObjectParams: Array<ServiceComponentParam> = [];

    if (simCardService.servicesParams && simCardService.servicesParams.length > 0) {
        for (let i = 0; i < simCardService.servicesParams.length; i++) {
            if (simCardService.servicesParams[i].mainname === 'componentParams') {
                isComponentParams = true;
                jsonObjectParams = JSON.parse(simCardService.servicesParams[i].value);
            }
        }
    }

    const changeCycleFlag = (checked: boolean): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_on_services')),
            'operation_on_services_change_cycle',
            {
                status: 3,
                simCardId: simCardService.simCardId,
                componentName: simCardService.simCardServiceType.mainname,
                params: '{}',
            } as ComponentParam,
            (): void => {
                setDisableRenew(!checked);
                setAlert(null);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    const onCheckBoxEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const name = event.target.name;
        const value = event.target.value;
        const checked = event.target.checked;
        if (!checked) {
            setAlert(
                <AlertInfo
                    onConfirm={(): void => changeCycleFlag(checked)}
                    onCancel={(): void => setAlert(null)}
                    confirmBtnText={'simcard:f.change_renew_status_confirm'}
                    cancelBtnText={'general:common.cancel'}
                    content="simcard:f.set_disable_renew"
                />
            );
        }
    };

    const f = 3;
    const s = 9;

    return (
        <TableRow>
            <TableCell classes={tableCellRoot} padding="none" align="right" />
            <TableCell classes={tableCellRoot} padding="none" align="left" colSpan={3}>
                <React.Fragment>
                    {isComponentParams && (
                        <GridContainer>
                            {jsonObjectParams &&
                                jsonObjectParams.map((row) => (
                                    <React.Fragment key={'componentParams' + row.name + simCardService.id}>
                                        <GridItem xs={f}>
                                            <I18n trans="simcard:f.param_name" />
                                        </GridItem>
                                        <GridItem xs={f}>{row.name}</GridItem>
                                        <GridItem xs={f}>
                                            <I18n trans="simcard:f.param_value" />
                                        </GridItem>
                                        <GridItem xs={f}>{row.value}</GridItem>
                                    </React.Fragment>
                                ))}
                        </GridContainer>
                    )}
                    <OplBmeUsage params={simCardService.servicesParams} />
                    {simCardService.expireOn && (
                        <GridContainer key={'componentParamsExpireOn' + simCardService.id}>
                            <GridItem xs={f}>
                                <I18n trans="simcard:f.param_name" />
                            </GridItem>
                            <GridItem xs={f}>
                                {!simCardService.singleShot && !simCardService.simCardServiceType.singleShotFlag && (
                                    <I18n trans="simcard:f.expiredOn" />
                                )}
                                {(simCardService.singleShot || simCardService.simCardServiceType.singleShotFlag) && (
                                    <I18n trans="simcard:f.expiredOn_singleShot" />
                                )}
                            </GridItem>
                            <GridItem xs={f}>
                                <I18n trans="simcard:f.param_value" />
                            </GridItem>
                            <GridItem xs={f}>
                                {simCardService.cycleSkip === -1 && !simCardService.singleShot && (
                                    <Checkbox
                                        title={i18next.t('simcard:f.disable_renew')}
                                        checked={!disableRenew}
                                        name="fupMonitorCheckDaysFailsViolationSendSms"
                                        onChange={onCheckBoxEvent}
                                    />
                                )}
                                {!disableRenew && simCardService.cycleSkip === -1 && DateHelperTs.format(simCardService.expireOn, 'YYYY-MM-DD')}
                                {((disableRenew && !simCardService.singleShot) || (simCardService.cycleSkip === 1 && !simCardService.singleShot)) && (
                                    <span style={{ textDecoration: 'line-through' }}>
                                        {DateHelperTs.format(simCardService.expireOn, 'YYYY-MM-DD')}
                                    </span>
                                )}
                                {alert}
                            </GridItem>
                        </GridContainer>
                    )}
                </React.Fragment>
            </TableCell>
        </TableRow>
    );
};
